import db from '../../db/db'
import { isToday } from './FormatDate'

export async function findActiveVisitByCardNumber({
  cardNumber = '',
  excludeVisitId,
  excludeVisitUuid,
}) {
  const normalizedCardNumber = `${cardNumber || ''}`.trim()

  if (!normalizedCardNumber) {
    return null
  }

  return db.visits
    .filter(visit => {
      const visitCardNumber = `${visit.card_number || ''}`.trim()
      const hasActiveVisit = !visit.exit_time || `${visit.exit_time}`.trim() === ''
      const isExcludedVisit =
        (excludeVisitUuid && visit.uuid === excludeVisitUuid) ||
        (excludeVisitId && visit.id === excludeVisitId)
      const entryDate = `${visit.entry_time || ''}`.split(' ')[0]
      const isEntryToday = entryDate ? isToday(entryDate) : false

      return (
        !isExcludedVisit &&
        visitCardNumber === normalizedCardNumber &&
        hasActiveVisit &&
        isEntryToday
      )
    })
    .first()
}
